import { configureStore } from '@reduxjs/toolkit';
import OrganizationListReducer from './slices/OrganizationSlice'
import UserReducer from './slices/UserSlice'
import NotesReducer from './slices/NotesSlice'

export const store = configureStore({
  reducer: {
    OrganizationListStore: OrganizationListReducer,
    UserStore: UserReducer,
    NotesStore: NotesReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
